export default {
  app: {
    label: {
      add: 'Ajouter',
      create: 'Créer',
      edit: 'Modifier',
      copy: 'Copier',
      save: 'Enregistrer',
      delete: 'Supprimer',
      ok: 'OK',
      cancel: 'Annuler',
      choose: 'Choisir',
      close: 'Fermer',
      reset: 'Réinitialiser',
      login: 'Se connecter',
      logout: 'Déconnexion',
      action: 'Action | Actions',
      assign: 'Assignier',
      search: 'Recherche',
      import: 'Importer',
      export: 'Exporter',
      detail: 'Détail | Détails',
      type: 'Type | Types',
      group: 'Groupe | Groupes',
      instance: 'Instance | Instances',
      all: 'Tout',
      admin: 'Admin',
      percent: 'Pourcent',
      validate: 'Valider',
      next: 'Suivant',
      previous: 'Précédent',
      summary: 'Sommaire',
      null: 'Nul',
      yes: 'Oui',
      no: 'Non',
      none: 'Aucune',
      inactive: 'Inactif',
      options: 'Options',
      locale: {
        en: 'Anglais',
        fr: 'Français',
      },
    },
    tip: {
      empty_list: 'La liste est vide, cliquez pour en ajouter',
      select_for_questions: 'Faites une sélection pour voir les questions',
    },
    title: {
      add: 'Nouveau {0}',
      edit: 'Modifier {0}',
    },
  },

  $vuetify: {
    dataTable: {
      itemsPerPageText: 'Rangées par page:',
      sortBy: 'Trier',
      ariaLabel: {
        sortNone: '@:app.label.none',
        activateAscending: 'Activer ascendant',
        activateDescending: 'Activer descendant',
        sortAscending: 'Trier ascendant',
        sortDescending: 'Trier descendant',
        activateNone: 'Activer aucun',
      },
    },
    dataIterator: {
      noResultsText: 'Aucun résultat',
      loadingText: 'Chargement... SVP attendre',
    },
    dataFooter: {
      pageText: '{0} - {1} de {2}',
      itemsPerPageAll: 'Tous',
      nextPage: '@:app.label.next',
      prevPage: '@:app.label.previous',
    },
    noDataText: 'Aucune donnée',
    close: '@:app.label.close',
  },

  validation: {
    error: {
      default: 'Il y a eu une erreur',
      required: 'Valeur requise',
      date: 'Date invalide, doit suivre le format AAAA-MM-DDTHH:mm:ssZ',
      unique: "La valeur n'est pas unique",
      email: "Le courriel n'est pas valide",
      confirmed: "La valeur n'a pas été confirmée",
      password:
        'Ce champ est obligatoire et doit contenir un minimum de 8 charactères incluant un chiffre, une lettre minuscule et une lettre majuscule.',
      regex: "La valeur n'est pas valide",
      url: "L'adresse de format URL n'est pas valide",
    },
    success: {
      add: '{0} a été ajouté',
      default: '{0} a été mis à jour',
      delete: '{0} a été supprimé',
      copy: '{0} a été copié',
    },
    confirmation: {
      delete: 'Êtes-vous certain de vouloir supprimer {0}?',
      surveyGroup: {
        activate: 'Voulez-vous activer tous les sondages dans {0}?',
        deactivate: 'Voulez-vous désactiver tous les sondages dans {0}?',
        close: 'Voulez-vous fermer tous les sondages dans {0}?',
        archived: 'Voulez-vous archiver tous les sondages dans le groupe?',
        particpants: "Participants n'ayant pas soumis :",
      },
      navigation:
        "Les changements sur cette page n'ont pas été saugardés. Voulez-vous procéder et perdre les changements?",
    },
  },

  navigation: {
    dashboard: 'Accueil',
    help: 'Aide',
    contactus: 'Contactez nous',
    system: 'Gestion du système',
    deployment: 'Déploiement',
  },

  model: {
    common: {
      id: 'ID',
      email: 'Courriel',
      name: 'Nom',
      label: 'Étiquette | Étiquettes',
      state: 'État',
      type: 'Type',
      scope: 'Étendue',
      parent: 'Parent',
      children: 'Enfant | Enfants',
      date: 'Date',
      createddate: 'Date de création',
      opendate: "Date d'ouverture",
      startdate: 'Lancement',
      closedate: 'Fermeture',
      enddate: 'Date de fin',
      submitteddate: 'Date de soumission',
      completeddate: 'Date de complétion',
      text: 'Texte',
      key: 'Clé | Clés',
      title: 'Titre',
      description: 'Description',
      participantCount: 'Nombre de participants',
      dueDate: 'Date dû',
      total: 'Total',
      active: 'Activé',
    },
    address: {
      line1: 'Adresse - ligne 1',
      line2: 'Adresse - ligne 2',
      unit: "No d'unité",
      streetnumber: 'No de rue',
      streetaddress: 'Rue',
      pobox: 'Case postale',
      city: 'Ville',
      province: 'Province',
      postalcode: 'Code Postal',
    },
    user: {
      label: 'Utilisateur | Utilisateurs',
      lastname: 'Nom',
      firstname: 'Prénom',
      username: "Nom d'utilisateur",
      password: 'Mot de passe',
      permission: 'Permission | Permissions',
      lastlogin: 'Dernière connexion',
      language: 'Langue de préférence',
    },
    role: {
      label: 'Rôle | Rôles',
      sp_privs: 'Privilèges au niveau fournisseur',
      oversight_privs: 'Privilèges au niveau gouvernance',
      oversight_children_privs: 'Privilèges au niveau gouvernance secondaire',

      type: {
        label: '@:model.common.type',
        oversight: '@:model.oversightOrganization.label',
        serviceprovider: '@:model.serviceProvider.label',
        superadmin: 'Super Administrateur',
        admin: '@:app.label.admin',
      },

      privileges: {
        readonly: 'Lecture',
        admin: '@:app.label.admin',
        accompany: 'Accompagnement',
        sub_org: '@:model.survey.suborg',
      },
    },
    oversightOrganization: {
      label: 'Organisation de gouvernance | Organisations de gouvernance',
    },
    oversightOrganizationType: {
      label: "Type d'organisation de gouvernance | Types d'organisation de gouvernance",
      childType: "Type d'enfants",
      childOversightOrganizationType: "Type enfants d'org. de gouvernance",
      childExclusive: 'Ensembles mutuellement exclusifs',
    },
    serviceProvider: {
      label: 'Fournisseur de service | Fournisseurs de service',
      parentOversight: 'Organisation de gouvernance',
    },
    serviceProviderType: {
      label: 'Type de fournisseur de service | Types de fournisseur de service',
    },
    automated: {
      email: {
        label: 'Courriel automatisé | Courriels automatisés',
        subject: 'Objet',
        usedefaultSignature: 'Utiliser une signature générale',
        defaultSignature: 'Signature',
        signature: 'Signature | Signatures',
        body: 'Corps',
        system: 'Courriel du système',
        emailCount: 'Nombre de courriels à envoyer',
        userCount: "Nombre d'utilisateurs qui recevront des courriels",
        multi: 'Multi',
        multilingual: 'Contenu multilingue',
      },
    },
    survey: {
      label: 'Sondage | Sondages',
      defaultstate: 'État du sondage par défaut',
      organization: 'Organisation',
      suborg: 'Sous-organisation',
      pointofservice: 'Point de service',
      options: {
        documents: {
          text: '@:model.document.label',
          value: 'Activer la librarie de documents',
        },
      },
    },
    surveyGroup: {
      label: 'Groupe de sondages | Groupes de sondages',
      includeArchived: 'Inclure les groupes archivés',
    },
    surveyParticipation: {
      label: 'Participation | Participants',
      submissionstate: 'Statut de soumission',
      progress: 'Progression',
    },
    surveyState: {
      label: 'Étape | Étapes',
      category: 'Categorie',
      editablebysp: 'Modifiable par le fournisseur',
      editablebyoversight: "Modifiable par l'agence de gouv.",
      spemailkey: 'Courriel au fournisseur',
      oversightemailkey: "Courriel à l'org. de gouvernance",
      nextstate: {
        label: 'Étape suivante',
        serviceprovider: 'Étapes suivantes (fournisseur)',
        oversight: 'Étapes suivantes (agence de gouv.)',
      },
    },
    question: {
      label: 'Question | Questions',
      questionnumber: 'Numéro de question (court)',
      fullquestionnumber: 'Numéro de question (complet)',
      condition: {
        label: 'Condition',
        key: 'Clé de la condition',
        answers: 'Réponses',
        text: 'Conditionel',
        noQuestions: "Aucune question n'est présentement visible",
      },
      shorttext: 'Texte court',
      longtext: 'Texte long',
      helptext: "Texte d'aide",
      permission: {
        label: '@:model.user.permission',
        visible: 'Visible',
        editable: 'Modifiable',
      },
      type: {
        clientele: 'Clientèle',
        contact_information: 'Contact',
        date: 'Date',
        human_resources: 'Ressources humaines',
        likert: 'Likert',
        long_text: 'Texte long',
        mailing_address: 'Adresse postale',
        multiple_choice: 'Choix multiples',
        multiple_choice_data_set: 'Choix multiples (jeux de données)',
        points_of_service: 'Points de service',
        rich_text: 'Texte enrichi',
        short_text: 'Texte court',
        sub_organization: 'Sous-organisation',
        table_format: 'Format tableau',
        text_block: 'Bloc de texte',
      },
      options: {
        label: '@:app.label.options',
        common: {
          indentation: 'Indentation',
          header: {
            visible: "Afficher l'entête de question",
          },
          documents: {
            visible: 'Permettre les documents en pièces jointes',
          },
          notes: 'Notes additionnelles',
        },
        summary: {
          progress: 'Progrès du sondage',
          state: {
            validation: "Voulez-changer l'état à {0}?",
            currentProgress: 'Le niveau de progrès du sondage est: {0}%',
            success: "L'état a été changé",
          },
        },
        human_resources: {
          source: 'Source',
          positioncounttype: 'Type du compte de postes',
          resource: 'Ressource',
          department: {
            active: 'Activer le champ « Département »',
            label: 'Nom du champ « Département »',
            labelDefault: 'Département',
          },
          position: {
            active: 'Activer le champ « Poste »',
            label: 'Nom du champ « Poste »',
            labelDefault: 'Poste',
            useDataset: "Recommender des valeurs provenant d'un jeu de données",
            dataset: '@:model.dataset.label',
          },
          language: {
            total: 'Total',
            totalfte: 'Total des ETP',
            totaldp: 'Total des PD',
            dbpfilledwith: 'PDB comblés avec comp. ling.',
            dbpfilledwithout: 'PDB comblés sans comp. ling.',
            vacant: 'Postes vacants',
            nondbp: 'Bilingues dans autres postes',
          },
        },
        likert: {
          showUnknown: 'Utiliser le choix inconnu',
          showNotes: 'Utiliser le champ @:model.question.options.common.notes',
          primary: 'Question primaire',
          showPrimary: 'Utiliser la question primaire',
          noterows: '@:model.question.options.common.notes Rows',
          language: {
            primary: {
              true: {
                label: 'Étiquette "vrai"',
                default: '@:app.label.yes',
              },
              false: {
                label: 'Étiquette "faux"',
                default: '@:app.label.no',
              },
              unknown: {
                label: 'Étiquette "inconnu"',
                default: 'Incertain',
              },
            },
            secondary: {
              question: {
                label: 'Étiquette de la question secondaire',
              },
            },
            notes: {
              label: '@:model.question.options.common.notes Label',
              default: '@:model.question.options.common.notes',
            },
          },
          secondary: {
            options: {
              text: '@:model.common.text',
              acronym: 'Abréviation',
              key: '@:model.common.key',
              score: 'Score',
            },
          },
        },
        longText: {
          rows: 'Nombre de rangées',
        },
        multiple_choice: {
          choices: {
            key: '@:model.common.key',
            text: '@:model.common.text',
          },
          type: '@:app.label.type',
          multiple: 'Choix multiples',
          other: {
            option: 'Option "Autre"',
            checkbox: 'Autre',
            label: 'Titre pour option "Autre"',
            default: 'Spécifier',
          },
          notes: {
            checkbox: 'Champ de notes',
            label: 'Étiquette du champ "Notes"',
            default: 'Notes additionnelles',
          },
          sort: 'Ordre de tri',
          displayalloptions: 'Afficher toutes les options en mode visionnement',
        },
        multiple_choice_data_set: {
          dataset: '@:model.dataset.label',
          type: {
            label: '@:model.common.type',
            enforce: 'Enforcer',
            guideline: 'Guide',
          },
          multiple: {
            label: 'Choix de sélection',
            true: 'Sélection multiples',
            false: 'Sélection unique',
          },
          label: {
            label: 'Étiquette du sélecteur',
          },
        },
        clientele: {
          percentage: {
            label: 'Étiquette du pourcentage de francophones',
            default: 'Pourcentage de francophones',
          },
          period: {
            label: 'Étiquette de la période',
            default: 'Année',
          },
          totalvisit: {
            label: 'Étiquette du nombre total de visites',
            default: 'Nombre total de visites',
          },
          francophonevisit: {
            label: 'Étiquette du nombre total de visites par un client francophone',
            default: 'Nombre de visites par un client francophone',
          },
          totalclients: {
            label: 'Étiquette du nombre total de clients',
            default: 'Nombre total de clients',
          },
          francophoneclients: {
            label: 'Étiquette du nombre total de clients francophones',
            default: 'Nombre total de clients francophones',
          },
        },
        points_of_service: {
          address: "Demander l'adresse",
          singlelabel: {
            label: 'Étiquette pour un seul point de service',
            default: 'Un seul',
          },
          multilabel: {
            label: 'Étiquette pour plusieurs points de service',
            default: 'Plusieurs',
          },
        },
        short_text: {
          options: {
            rules: {
              label: 'Règle de validation',
              none: '@:app.label.none',
              regex: 'Regex',
              email: 'Courriel',
              url: 'URL',
            },
            errorMessage: "Message d'erreur personalisé",
          },
        },
        sub_organization: {
          singlelabel: {
            label: 'Étiquette pour une seule organisation',
            default: 'Une seul',
          },
          multilabel: {
            label: 'Étiquette pour plusieurs sous-organisation',
            default: 'Plusieurs',
          },
        },
        table_format: {
          header: 'Entête de la colonne',
          question: '@:model.question.label',
        },
        text_block: {
          text: 'Texte additionnel',
        },
        contact_information: {
          firstname: '@:model.user.firstname',
          lastname: '@:model.user.lastname',
          initial: 'Initial',
          title: 'Titre',
          email: 'Courriel',
          phone: 'Numéro de téléphone',
          extension: 'Poste',
        },
      },
      validation: {
        label: 'Validation',
        mandatory: {
          label: 'Obligation de réponse',
          options: {
            none: 'Non obligatoire',
            soft: 'Calcul pour le progrès seulement',
            submit: 'Obligatoire (Bloque la soumission)',
          },
        },
      },
    },
    page: {
      label: 'Page | Pages',
      shortname: 'Nom court',
      longname: 'Nom long',
      level: 'Niveau',
    },
    section: {
      label: 'Section | Sections',
      toc: 'Table des matières',
    },
    log: {
      label: 'Journal | Journal',
      surveyName: 'Sondage',
      serviceProviderName: 'Fournisseur de services',
      questionKey: 'Clé de la question',
      requestPayload: 'Contenu de la requête',
      callerIP: 'Adresse IP',
      callerBrowser: 'Navigateur',
    },
    email: {
      label: 'Courriel | Courriels',
    },
    functionalcenter: {
      label: 'Centre fonctionnel | Centres fonctionnels',
      code: 'Code',
    },

    worksheet: {
      label: 'Feuille de travail | Feuilles de travail',
      name: '@:model.common.name',
      active: '@:model.common.active',
      layout: {
        label: '@:page.survey.details.layoutTab',
        header: {
          label: 'Item',
          name: 'Nom de la colonne',
          question: '@:model.question.label',
        },
      },
    },

    document: {
      label: 'Document | Documents',
      file: 'Fichier',
      name: '@:model.common.name',
      description: '@:model.common.description',
      associations: '@:model.question.label',
      uploaddate: 'Date de téléversement',
    },

    bookshelf: {
      label: 'Étagère | Étagères',
      name: '@:model.common.name',
      notes: "Notes à l'administrateur",
      layout: {
        label: 'Disposition',
        type: '@:model.common.type',
        title: '@:model.common.title',
        description: '@:model.common.description',
        value: {
          url: 'URL',
          text: 'Texte',
        },
        options: {
          collapsed: 'Réduit par défaut',
        },
        children: '@:model.common.children',
        language: {
          label: 'Langue',
          any: 'Toutes',
        },
      },
    },

    resource: {
      label: 'Ressource | Ressources',
      name: '@:model.common.name',
      file: '@:model.document.file',
    },

    deployment: {
      label: 'Déploiement',
      name: '@:model.deployment.label',
      version: {
        label: 'Version'
      },
      contactInfo: {
        label: 'Informations de contact'
      },
    },

    dataset: {
      label: 'Jeu de données | Jeux de données',
      key: '@:model.common.key',
      name: '@:model.common.name',
      oversighttype: '@:model.oversightOrganizationType.label',

      content: {
        label: 'Contenu du jeu de données',
        id: '@:model.common.id',
        key: '@:model.common.key',
        name: '@:model.common.name',
        oversights: '@:model.oversightOrganization.label',
      },
    },

    dashboard: {
      label: 'Tableau de bord',
      canvas: {
        label: 'Canvas',
        left: 'Gauche',
        right: 'Droite',
      },
      tile: {
        label: 'Tableau de bord',
        type: {
          label: '@:model.common.type',
          bookshelf: '@:model.bookshelf.label',
          likert_score: 'Score de Likert',
          multiple_choice_frequency: 'Fréquence de choix multiples',
          notifications: 'Notifications',
          submission_status: 'Statut de soumission',
          survey_progress: 'Progrès du sondage',
        },

        bookshelf: {
          bookshelf: '@:model.bookshelf.label',
        },

        likert_score: {
          denominator: {
            label: 'Denominateur',
            answercount: 'Réponses totales',
            netcount: 'Total de questions',
          },
        },

        multiple_choice_frequency: {
          style: {
            label: 'Style de graphique',
            aggregate: 'Aggrégé',
            stack: 'Empilé',
            group: 'Groupé',
          },
        },
      },
    },

    useragreement: {
      label: "Entente d'utilisateur | Ententes d'utilisateur",
      name: '@:model.common.name',
      text: '@:model.common.text',
      checkboxlabel: 'Texte de la case à cocher',
      active: '@:model.common.active',
    },

    notification: {
      label: 'Notification | Notifications',
      name: '@:model.common.name',
      text: '@:model.common.text',
      datepublished: 'Publiée',
    },
  },

  page: {
    user: {
      list: {
        title: 'Liste des utilisateurs',
      },
      add: {
        title: "Ajouter l'utilisateur",
        submitAndEmail: 'Enregistrer et envoyer un courriel',
      },
      details: {
        title: "Détails de l'utilsateur",
        resetPassword: {
          label: 'Réinitialiser le mot de passe',
          generate: 'Générer',
          setResetPasswordState: "Forcer le changement de mot de passe lors de la prochaine connexionn",
          success: "Le mot de passe de l'utilisateur a été changé",
        },
        sendEmail: {
          label: 'Envoyer un courriel',
          success: "Le courriel a été envoyé à l'utilisateur",
        },
      },
    },

    login: {
      forgotPassword: 'Oublié votre mot de passe?',
      emailOrUsername: "Courriel ou nom d'utilisateur",
      forgotPasswordInstructions:
        "SVP entrez votre courriel ou votre nom d'utilisateur pour que nous puissions vous envoyer la marche à suivre",
      toLogin: "Retour à l'écran de connexion",
      resetPassword: 'Réinitialiser le mot de passe',
      forgotPasswordEmailSent:
        'Un courriel vous a été envoyé avec la marche à suivre pour réinitialiser votre mot de passe',
      resetPasswordInstructions:
        'Vous devez réinitialiser votre mot de passe avant de continuer',
      resetPasswordSuccess: 'Mot de passe mis à jour avec succès',
      chooseRole: 'Choisir un rôle',
    },

    profile: {
      title: 'Modifier le profil',
      details: {
        navigation: 'Profil',
        personal: 'Information personnelle',
      },
      email: {
        navigation: 'Courriel',
        currentEmail: 'Votre courriel est présentement {email}',
        newEmail: 'Nouvelle adresse courriel',
      },
      password: {
        navigation: 'Mot de passe',
        password: {
          old: 'Ancien mot de passe',
          new: 'Nouveau mot de passe',
          confirm: 'Confirmer le nouveau mot de passe',
        },
      },
    },

    dashboard: {
      oversight: {
        title: '@:navigation.dashboard',
      },
      provider: {
        title: '@:navigation.dashboard',
        survey: {
          view: 'Voir le sondage',
        },
      },

      tile: {
        type: {
          likert_score: {
            title: '@:model.common.title',
            scorelabel: "Étiquette de l'axe des score",

            gradients: {
              label: 'Couleur',
              start: 'Début',
              middle: 'Milieu',
              end: 'Fin',
            },

            questions: {
              label: '@:model.question.label',
              key: '@:model.common.key',
              display: "Étiquette",
            },

            scores: {
              label: 'Scores',
              score: 'Score',
              display: 'Étiquette',
            },
          },

          multiple_choice_frequency: {
            title: '@:model.common.title',
            xaxes: "Étiquette de l'axe des X",
            yaxes: "Étiquette de l'axe des Y",
            stack: 'Empiler les questions',
            horizontal: "Orientation horizontale",
            questions: {
              label: '@:model.question.label',
              key: '@:model.common.key',
              display: 'Étiquette',
            },
            answers: {
              label: 'Réponses',
              key: '@:model.common.key',
              display: 'Étiquette',
            },
          },

          submission_status: {
            title: '@:model.common.title',
            notstarted: 'Non-débuté',
            notsubmitted: 'Non-soumis',
            submitted: 'Soumis',
            complete: 'Complétés',
          },
        },
      },
    },

    role: {
      list: {
        title: 'Liste des rôles',
      },
      add: {
        title: 'Ajouter le rôle',
      },
      details: {
        title: 'Détails du rôle',
        notes: "Notes de l'administrateur",
      },
    },

    oversightOrganization: {
      add: {
        title: "Ajouter l'organisation de gouvernance",
      },
      details: {
        title: "Détails de l'organisation de gouvernance",
      },
    },

    oversightOrganizationType: {
      add: {
        title: "Ajouter le type d'organisation de gouvernance",
      },
      details: {
        title: "Détails du type d'organisation",
      },
    },

    serviceProvider: {
      list: {
        showInactive: 'Afficher les entrées inactives',
      },
      add: {
        title: 'Ajouter le fournisseur de services',
      },
      details: {
        title: 'Détails du fournisseur de services',
      },
      changeState: {
        title: "Changer l'état du fournisseur",
        success: 'État mis à jour avec succès',
        activate: 'Activer',
        deactivate: 'Désactiver',
        usersList: 'Les utilisateurs suivants seront affectés:',
        surveyList: 'Ces participations au sondage seront affectées:',
      },
    },

    serviceProviderType: {
      add: {
        title: 'Ajouter le type de fournisseur de services',
      },
      details: {
        title: 'Détails du type de fournisseur de services',
      },
    },

    survey: {
      add: {
        title: 'Ajouter un sondage',
      },
      details: {
        title: 'Sondage',
        layoutTab: 'Disposition',
        previewTab: 'Aperçu',
        organizationNomenclature: "Nomenclature de l'organisation",
        options: '@:app.label.options',
      },
      participants: {
        bulkEdit: 'Modification en vrac',
        title: 'Options de participation',
        copy: {
          title: 'Copier les réponses',
        },
      },
      questions: {
        used: 'Utilisé',
      },
      duplicateHelp:
        'Ceci va créer un nouveau sondage avec les informations suivantes et copiera toutes les données du sondage sélectionné (sections, questions, mise en page, participants, etc ...)',
      report: {
        contents: 'Table des matières',
        downloadPDF: 'Télécharger en PDF',
        downloadInProgress: 'Le téléchargement va débuter bientôt',
      },
      validate: {
        success: 'Le sondage est validé',
        error: "Le sondage n'est pas valide",
      },
    },

    surveyGroup: {
      add: {
        title: 'Ajouter un groupe de sondage',
      },
      details: {
        title: 'Groupe de sondage',
      },
    },

    automatedEmails: {
      add: {
        title: 'Ajouter un courriel automatisé',
      },
      details: {
        title: 'Détails du courriel automatisé',
      },
      send: {
        title: 'Envoyer les courriels',
        submit: '@:page.automatedEmails.send.title',
        test: 'Envoyer un courriel test',
        validation: {
          success: 'Les courriels ont été envoyés',
          test: 'Le courriel test a été envoyé',
        },
      },
    },

    document: {
      upload: 'Téléverser un document',
      management: 'Gestionnaire de documents',
      linkedTo: 'Choisir les documents reliés à {0}',
      bulkDownload: 'Téléchargement en vrac',
      showAll: 'Afficher tous les documents',
    },

    bookshelf: {
      add: {
        title: "Ajouter une étagère",
      },
      edit: {
        title: "Modifier l'étagère",
      },
    },

    dataset: {
      create: {
        title: 'Ajouter un jeu de données',
      },
      edit: {
        title: 'Modifier un jeu de données',
      },
      validate: {
        invalidJSON: 'le champ de format JSON est invalide',
        import: 'Importé avec succès',
      },
      notEditable: 'Le contenu ne peut être changé tant que le jeu de données ne soit enregistré',
      import: {
        file: '@:model.document.file',
        mode: {
          label: 'Import Mode',
          ignoreduplicate: 'Ignore Duplicates',
          purge: 'Purge',
        },
      },
    },

    useragreement: {
      add: {
        title: 'Ajouter une entente',
      },

      edit: {
        title: "Modifier l'entente",
      },
    },

    notification: {
      add: {
        title: 'Ajouter une notification',
      },

      edit: {
        title: 'Modifier la notification',
        publish: 'Publier',
        confirmPublish: 'Êtes-vous certain de vouloir publier cette notification?',
      },

      validate: {
        publish: 'Notification publiée',
      },
    },

    contactInfo: {
      contactLogin: {
        title: 'Informations de la page de connexion',
        description: 'Ces informations apparaîtront sur la page de connexion (login)'
      },
      contactMenu: {
        title: 'Informations du menu principal',
        description: "Ces informations apparaîtront dans le menu principal, sous l'onglet 'accueil'"
      },
    },
  },
};
